var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGalleryIcon = function SvgGalleryIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33337 23.2L7.95707 19.2139C8.35383 18.7775 9.04019 18.7775 9.43695 19.2139L12.3207 22.3861C12.7175 22.8225 13.4038 22.8225 13.8006 22.3861L19.9571 15.6139C20.3538 15.1775 21.0402 15.1775 21.437 15.6139L28.3334 23.2M13.9334 11.2C13.9334 12.5255 12.8589 13.6 11.5334 13.6C10.2079 13.6 9.13337 12.5255 9.13337 11.2C9.13337 9.87452 10.2079 8.8 11.5334 8.8C12.8589 8.8 13.9334 9.87452 13.9334 11.2ZM5.33337 28H27.3334C27.8857 28 28.3334 27.5523 28.3334 27V5C28.3334 4.44772 27.8857 4 27.3334 4H5.33337C4.78109 4 4.33337 4.44772 4.33337 5V27C4.33337 27.5523 4.78109 28 5.33337 28Z",
    stroke: "var(--on-surface)",
    strokeWidth: 2
  })));
};
export default SvgGalleryIcon;